
export function isValidBusinessId(value, msg = 'error.invalid') {
  const valueNumber = value.replace(/[- ]/g, '');
  return validateAll(valueNumber,
    v => isValidLength(v, msg, 8),
    v => isValidNumber(v, msg)) === null ? '' : msg;
}

function isValidLength(value, errorKeys = {}, expectedLength) {
  const keys = {
    empty: errorKeys.empty ?? 'error.empty',
    invalidLength: errorKeys.invalidLength ?? 'error.invalidLength'
  };
  if (!value || value.trim().length === 0) {
    return keys.empty;
  }
  if (value.trim().length !== expectedLength) {
    return keys.invalidLength;
  }
  return null;
}


function isValidNumber(value, errorKeys = {}) {
  const keys = {
    empty: errorKeys.empty ?? 'error.empty',
    notNumber: errorKeys.notNumber ?? 'error.notNumber'
  };

  if (value === null || value === undefined || value === '') {
    return keys.empty;
  }
  const number = Number(value);
  if (isNaN(number)) {
    return keys.notNumber;
  }
  return null;
}

function validateAll(value, ...validators) {
  for (let validator of validators) {
    const error = validator(value);
    if (error) {
      return error;
    }
  }
  return null;
}
